import { applyMiddleware, combineReducers, createStore, compose } from 'redux';

import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunkMiddleware from 'fsa-redux-thunk';

import { reducer as app } from './services/app';
import { reducer as auth } from './services/auth';
import { reducer as dashboard } from './services/dashboard';
import { reducer as users } from './services/users';
import { reducer as userProfile } from './services/userProfile';
import { reducer as match } from './services/match';
import { reducer as photos } from './services/photos';
import { reducer as swipes } from './services/swipes';
import { reducer as matches } from './services/matches';
import { reducer as messages } from './services/messages';
import { reducer as reports } from './services/reports';
export const history = createBrowserHistory();

let rootReducer = combineReducers({
  router: connectRouter(history),
  app,
  auth,
  dashboard,
  users,
  userProfile,
  match,
  photos,
  swipes,
  matches,
  messages,
  reports,
});

const store = createStore(
  rootReducer,
  compose(
    // window.__REDUX_DEVTOOLS_EXTENSION__ &&
    // window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(thunkMiddleware, routerMiddleware(history))
  )
);

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept('./store', () => {
      store.replaceReducer(rootReducer);
    });
  }
}

export default store;
